import { render, staticRenderFns } from "./getVolunteering.vue?vue&type=template&id=bf189ca4"
import script from "./getVolunteering.vue?vue&type=script&lang=js"
export * from "./getVolunteering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports